export default __webpack_public_path__ + "static/media/location-icon.9b2710c6.svg";